import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getBoxPositionOnWindowCenter = function getBoxPositionOnWindowCenter(width, height) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2
  };
};
var SHARE_WINDOW_WIDTH = 800;
var SHARE_WINDOW_HEIGHT = 600;
var setupSocialShareButtons = function setupSocialShareButtons() {
  var shareButtonContainer = document.querySelector('.SocialShareButtons');
  if (!shareButtonContainer) return;
  var shareButtons = shareButtonContainer.querySelectorAll('.ShareButton');
  shareButtons.forEach(function (shareButton) {
    shareButton.addEventListener('click', function (event) {
      event.preventDefault();
      var options = _objectSpread(_objectSpread({}, getBoxPositionOnWindowCenter(SHARE_WINDOW_WIDTH, SHARE_WINDOW_HEIGHT)), {}, {
        width: SHARE_WINDOW_WIDTH,
        height: SHARE_WINDOW_HEIGHT,
        location: 'no',
        toolbar: 'no',
        status: 'no',
        directories: 'no',
        menubar: 'no',
        scrollbars: 'yes',
        resizable: 'no',
        centerscreen: 'yes',
        chrome: 'yes'
      });
      var optionsString = Object.keys(options).map(function (key) {
        return "".concat(key, "=").concat(options[key]);
      }).join(',');
      window.open(shareButton.href, null, optionsString);
    });
  });
};
export default setupSocialShareButtons;